import wx from "weixin-js-sdk";
import utils from "@/common/utils/utils";
export default {
  data() {
    return {
    }
  },
  created() {
  },
  methods: {
    initShare(title, desc) {
      const entryLink = utils.getEntryLink();
      console.log('entryLink', entryLink)
      this.$axios
        .get("/api/api/web/Wechat/GetWechat?backUrl=" + entryLink)
        .then((res) => {
          wx.config({
            debug: false,
            appId: res.Data.AppId,
            timestamp: res.Data.TimesTamp,
            nonceStr: res.Data.NonceStr,
            signature: res.Data.She1Str,
            jsApiList: ["updateAppMessageShareData", "updateTimelineShareData"],
            openTagList: ["wx-open-launch-weapp"],
          });
          wx.checkJsApi({
            jsApiList: [
              // 所有要调用的 API 都要加到这个列表中
              "updateAppMessageShareData", // 分享到朋友圈接口
              "updateTimelineShareData", //  分享到朋友接口
            ],
            success: async function (res) {
              wx.ready(() => {
                wx.updateAppMessageShareData({
                  title: title ? title : '华肤荟',
                  link: window.location.href,
                  desc: desc ? desc : '权威 专业 赋能——您身边的皮肤科链接圈',
                  imgUrl: process.env.VUE_APP_BASE_URL + "/api/img/sharecover.jpg",
                  success: function (res) { },
                });
                wx.updateTimelineShareData({
                  title: title ? title : '华肤荟',
                  link: window.location.href,
                  desc: desc ? desc : '权威 专业 赋能——您身边的皮肤科链接圈',
                  imgUrl: process.env.VUE_APP_BASE_URL + "/api/img/sharecover.jpg",
                  success: function (res) { },
                });
              });
            },
          });
        });
    },

    initzqShare(title, desc, img) {
      const entryLink = utils.getEntryLink();
      console.log('entryLink', entryLink)
      this.$axios
        .get("/api/api/web/Wechat/GetWechat?backUrl=" + entryLink)
        .then((res) => {
          wx.config({
            debug: false,
            appId: res.Data.AppId,
            timestamp: res.Data.TimesTamp,
            nonceStr: res.Data.NonceStr,
            signature: res.Data.She1Str,
            jsApiList: ["updateAppMessageShareData", "updateTimelineShareData"],
            openTagList: ["wx-open-launch-weapp"],
          });
          wx.checkJsApi({
            jsApiList: [
              // 所有要调用的 API 都要加到这个列表中
              "updateAppMessageShareData", // 分享到朋友圈接口
              "updateTimelineShareData", //  分享到朋友接口
            ],
            success: async function (res) {
              wx.ready(() => {
                wx.updateAppMessageShareData({
                  title: title ? title : '华肤荟',
                  link: window.location.href,
                  desc: desc ? desc : '权威 专业 赋能——您身边的皮肤科链接圈',
                  imgUrl: img ? process.env.VUE_APP_BASE_URL + img : process.env.VUE_APP_BASE_URL + "/api/img/sharecover.jpg",
                  success: function (res) { },
                });
                wx.updateTimelineShareData({
                  title: title ? title : '华肤荟',
                  link: window.location.href,
                  desc: desc ? desc : '权威 专业 赋能——您身边的皮肤科链接圈',
                  imgUrl: img ? process.env.VUE_APP_BASE_URL + img : process.env.VUE_APP_BASE_URL + "/api/img/sharecover.jpg",
                  success: function (res) { },
                });
              });
            },
          });
        });
    },

    initacmedShare(title, desc) {
      const entryLink = utils.getEntryLink();
      console.log('entryLink', entryLink)
      this.$axios
        .get("/api/api/web/Wechat/GetWechat?backUrl=" + entryLink)
        .then((res) => {
          wx.config({
            debug: false,
            appId: res.Data.AppId,
            timestamp: res.Data.TimesTamp,
            nonceStr: res.Data.NonceStr,
            signature: res.Data.She1Str,
            jsApiList: ["updateAppMessageShareData", "updateTimelineShareData"],
          });
          wx.checkJsApi({
            jsApiList: [
              // 所有要调用的 API 都要加到这个列表中
              "updateAppMessageShareData", // 分享到朋友圈接口
              "updateTimelineShareData", //  分享到朋友接口
            ],
            success: async function (res) {
              wx.ready(() => {
                wx.updateAppMessageShareData({
                  title: title ? title : 'ACMED第一届学术年会',
                  link: window.location.href,
                  desc: desc ? desc : '8月22日-24日，诚邀您的关注与参加！',
                  imgUrl: process.env.VUE_APP_BASE_URL + "/api/img/acmedshare.jpg",
                  success: function (res) { },
                });
                wx.updateTimelineShareData({
                  title: title ? title : 'ACMED第一届学术年会',
                  link: window.location.href,
                  desc: desc ? desc : '8月22日-24日，诚邀您的关注与参加！',
                  imgUrl: process.env.VUE_APP_BASE_URL + "/api/img/acmedshare.jpg",
                  success: function (res) { },
                });
              });
            },
          });
        });
    },

    initccdsShare(title, desc) {
      const entryLink = utils.getEntryLink();
      console.log('entryLink', entryLink)
      this.$axios
        .get("/api/api/web/Wechat/GetWechat?backUrl=" + entryLink)
        .then((res) => {
          wx.config({
            debug: false,
            appId: res.Data.AppId,
            timestamp: res.Data.TimesTamp,
            nonceStr: res.Data.NonceStr,
            signature: res.Data.She1Str,
            jsApiList: ["updateAppMessageShareData", "updateTimelineShareData"],
          });
          wx.checkJsApi({
            jsApiList: [
              // 所有要调用的 API 都要加到这个列表中
              "updateAppMessageShareData", // 分享到朋友圈接口
              "updateTimelineShareData", //  分享到朋友接口
            ],
            success: async function (res) {
              wx.ready(() => {
                wx.updateAppMessageShareData({
                  title: title ? title : 'CCDS|第四届中国皮肤外科大会',
                  link: window.location.href,
                  desc: desc ? desc : '9月12日-14日，诚邀您的关注与参加！',
                  imgUrl: process.env.VUE_APP_BASE_URL + "/api/img/ccdsshare.jpg",
                  success: function (res) { },
                });
                wx.updateTimelineShareData({
                  title: title ? title : 'CCDS|第四届中国皮肤外科大会',
                  link: window.location.href,
                  desc: desc ? desc : '9月12日-14日，诚邀您的关注与参加！',
                  imgUrl: process.env.VUE_APP_BASE_URL + "/api/img/ccdsshare.jpg",
                  success: function (res) { },
                });
              });
            },
          });
        });
    },

    initbjShare(title, desc) {
      const entryLink = utils.getEntryLink();
      console.log('entryLink', entryLink)
      this.$axios
        .get("/api/api/web/Wechat/GetWechat?backUrl=" + entryLink)
        .then((res) => {
          wx.config({
            debug: false,
            appId: res.Data.AppId,
            timestamp: res.Data.TimesTamp,
            nonceStr: res.Data.NonceStr,
            signature: res.Data.She1Str,
            jsApiList: ["updateAppMessageShareData", "updateTimelineShareData"],
          });
          wx.checkJsApi({
            jsApiList: [
              // 所有要调用的 API 都要加到这个列表中
              "updateAppMessageShareData", // 分享到朋友圈接口
              "updateTimelineShareData", //  分享到朋友接口
            ],
            success: async function (res) {
              wx.ready(() => {
                wx.updateAppMessageShareData({
                  title: title ? title : '第九届北京肿瘤防治研究会年会暨第十九届绿荫沙龙学术年会',
                  link: window.location.href,
                  desc: desc ? desc : '',
                  imgUrl: process.env.VUE_APP_BASE_URL + "/api/img/bjshare.jpg",
                  success: function (res) { },
                });
                wx.updateTimelineShareData({
                  title: title ? title : '第九届北京肿瘤防治研究会年会暨第十九届绿荫沙龙学术年会',
                  link: window.location.href,
                  desc: desc ? desc : '',
                  imgUrl: process.env.VUE_APP_BASE_URL + "/api/img/bjshare.jpg",
                  success: function (res) { },
                });
              });
            },
          });
        });
    },
  }
}